import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { PaginationOptions, SavedViewsQuery } from "lib/generated/app-service-gql/graphql";
import { useSavedViewsDataType } from "lib/hooks/api/saved_views/useSavedViews";
import { SavedViewDataType } from "lib/types/graphQLEnums";

export type PinnedView = { savedViewId: string; rank: number };

export function usePinnedViews(
  dataType: SavedViewDataType,
  options?: UseQueryOptions<SavedViewsQuery, unknown, SavedViewsQuery, QueryKey>,
) {
  const { data, ...rest } = useSavedViewsDataType(
    dataType,
    { pinned: true },
    { page: 1, pageSize: 100 } as PaginationOptions,
    options,
  );
  return {
    data: data?.results.map(
      (v): PinnedView => ({
        savedViewId: v.id,
        // pinnedRank is always non-null here: the server filters with
        // isNotNull(pinnedSavedViews.rank) when pinned: true, so any null
        // would indicate a bug in the server contract.
        rank: v.pinnedRank ?? 0,
      }),
    ),
    ...rest,
  };
}
